import React, {Fragment} from 'react'
import Config from '../launch/config'
import EntityPreview from '../entity/preview'
import {getFactionTextColor} from './utils'
import UnknownContent from './unknown-content'

import './css/entity-info.css'

const EntityInfo = ({entity, isModalOpen}) => {
    const {
        colonized,
        discovered,
        faction,
        isHomePlanet,
        isMiningResources,
        name,
        type,
    } = entity
    const difficulty = Config.difficultyLevels[Config.difficulty]
    const seconds = (
        (difficulty.planetMineResourceDelay % 60000) /
        1000
    ).toFixed(0)

    if (!discovered) {
        return <UnknownContent />
    }

    return (
        <Fragment>
            <div className="entity-info__preview">
                <EntityPreview entity={entity} isModalOpen={isModalOpen} />
            </div>
            <div className="entity-info__description">
                <h1 className="modal-heading">
                    {isHomePlanet && (
                        <Fragment>
                            <img
                                alt="home"
                                src={`${process.env.PUBLIC_URL}/img/home-green.png`}
                                style={{height: '16px'}}
                            />{' '}
                        </Fragment>
                    )}
                    <span style={{color: `#${getFactionTextColor(faction)}`}}>
                        {name}
                    </span>{' '}
                    <span className="modal-value">({type})</span>
                </h1>

                {colonized && faction === Config.userFactionName && (
                    <p style={{color: `#${Config.colorGreen}`}}>
                        {isHomePlanet ? 'Home' : 'Colonized'}
                    </p>
                )}
                {isMiningResources && (
                    <p>
                        This {type} is currently producing{' '}
                        <img
                            alt="resources"
                            className="modal-inline-img"
                            src={`${process.env.PUBLIC_URL}/img/resources-green.png`}
                        />
                        <span style={{color: `#${Config.colorGreen}`}}>
                            {difficulty.planetMineResourceRate}
                        </span>{' '}
                        every {seconds} seconds
                    </p>
                )}
            </div>
        </Fragment>
    )
}

export default EntityInfo
